// `access.changed` and `access.revoked` (spec/09-realtime-protocol.md §3, §6, §9; spec/07 §3.5, §6.5).
//
// Sent on `member:{id}` when what that member may do has changed: their role, their venues, or
// their membership itself. It carries nothing — "refetch `/v1/me/access`" is the whole message —
// because what the member may now see is exactly the question the console must ask the server
// rather than be told over a channel. The gateway also drops that member's subscriptions that are
// no longer allowed (spec/09 §3).
//
// The server publishes it from the outbox today; the gateway that delivers it to consoles is
// F-RT (#379, M2).
import { z } from "../zod.js";
import { ACCESS_CHANGED, ACCESS_REVOKED } from "./constants.js";
import { realtimeMessage } from "./envelope.js";
export { ACCESS_CHANGED, ACCESS_REVOKED };
export const AccessChangedPayloadSchema = z
    .object({})
    .strict()
    .openapi('AccessChangedPayload', { description: 'Nothing: refetch `/v1/me/access`.' });
/** `evt` on `member:{id}`. */
export const AccessChangedMessage = realtimeMessage('evt', ACCESS_CHANGED, AccessChangedPayloadSchema);
// ---------------------------------------------------------------------------------------------
// `access.revoked` (F-IAM-07, spec/07 §3.5, spec/20 §3)
// ---------------------------------------------------------------------------------------------
//
// Sent on `player:{id}` and on every `member:{id}` of a person whose sign-in has just stopped
// working everywhere — banned from the Platform. Every session they held is already revoked when it
// is published; the frame is how their open sockets hear it. The gateway passes it on and then
// closes each of that person's sockets with `4403` (spec/09 §9), and a reconnect is refused because
// there is no session left to mint a realtime token from.
//
// It carries nothing — no reason, no scope, no expiry. A ban's reason is internal (spec/07 §3.5),
// and a client has nothing to decide beyond "sign out".
export const AccessRevokedPayloadSchema = z
    .object({})
    .strict()
    .openapi('AccessRevokedPayload', {
    description: 'Nothing: this sign-in no longer works anywhere. The gateway closes the socket with 4403.',
});
/** `evt` on `player:{id}` and `member:{id}`. */
export const AccessRevokedMessage = realtimeMessage('evt', ACCESS_REVOKED, AccessRevokedPayloadSchema);
//# sourceMappingURL=access.js.map